import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'camelCaseConvert'
})
export class CamelCaseConvertPipe implements PipeTransform {

  transform(value: string): string {
    if (!value) {
      return '';
    }

    // Use a regular expression to add a space before each uppercase letter
    const spacedString = value.replace(/([a-z])([A-Z])/g, '$1 $2');

    // Capitalize the first letter of the string
    return spacedString.charAt(0).toUpperCase() + spacedString.slice(1);
  }
}
